import React, { FC } from 'react'

import { IconCurrentChargesProps } from './IconCurrentCharges.types'
import * as Styled from './styles/IconCurrentCharges.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCurrentCharges: FC<IconCurrentChargesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCurrentChargesProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconCurrentChargesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M-16-16h192v192H-16z' fill='none' />
        <path
          d='M100 120H68.24c2-4.19 3.76-10.53 3.76-20v-4h16a4 4 0 0 0 0-8H72V72c0-1.23.34-12 12-12 11.29 0 12 10 12 12a4 4 0 0 0 8 0c0-6.92-4.18-20-20-20S64 65.08 64 72v16h-4a4 4 0 0 0 0 8h4v4c0 15.71-5.22 20-5.87 20.46a3.8 3.8 0 0 0-2.21 4.36A4.1 4.1 0 0 0 60 128h40a4 4 0 0 0 0-8z'
          fill='#333'
        />
        <g fill='none' stroke='#333' strokeLinejoin='round' strokeWidth='8'>
          <path d='M132 36 100 4H40a12 12 0 0 0-12 12v128a12 12 0 0 0 12 12h80a12 12 0 0 0 12-12z' />
          <path d='M100 4.23V36h32' />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCurrentCharges
